import { Alert, Button, Card, Text } from '@/ui'
import { TypographyStyles } from '@/styles'
import {
  planWithCadenceLabel,
  useCatalogTierDisplayNames,
  formatPlanDate,
} from './lib/helpers'
import type { PendingPlanChange } from './lib/planChange.types'

export interface PendingChangeBannerProps {
  pendingChange: PendingPlanChange
  onCancel: () => Promise<void>
  cancelError: string | null
}

export const PendingChangeBanner = ({
  pendingChange,
  onCancel,
  cancelError,
}: PendingChangeBannerProps) => {
  const names = useCatalogTierDisplayNames()
  const effectiveDate = formatPlanDate(pendingChange.effectiveAt)

  return (
    <Card className="flex flex-col gap-2">
      <Text variant={TypographyStyles.BODY_MD}>
        Your plan is changing to{' '}
        {planWithCadenceLabel(
          names[pendingChange.toTier],
          pendingChange.toCadence
        )}
        , on {effectiveDate}.
      </Text>
      {cancelError && <Alert variant="error">{cancelError}</Alert>}
      <Button variant="secondary" className="self-start" onClick={onCancel}>
        Cancel change
      </Button>
    </Card>
  )
}
